<section
  class="toggle-form harc-copy-activity"
  [ngClass]="{ active: isCreateHardCopyActivitySliderOpen }"
>
  <div class="formwrap">
    <p-panel header={{sliderHeaderText}}>
      <ng-template pTemplate="icons">
        <p-button
        appPreventDoubleClick
          styleClass="p-button-text"
          id="hardCopyActivityCloseBtn"
          type="button"
          label="Close"
          class="align-right"
          (debounceClick)="confirm()"
        ></p-button>
      </ng-template>
      <div></div>
      <form [formGroup]="hardCopyActivityForm">
        <div *ngIf="errorMessages.length > 0">
          <p-messages severity="error">
            <ng-template pTemplate>
              <span class="p-message-icon pi pi-times-circle"></span>
              <span class="p-ml-2">Please correct the following errors. </span>
              
              <ul>
                <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
              </ul>
            </ng-template>
          </p-messages>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <label for="Activity"><b>Activity</b></label>
            <div>
              <p-radioButton
                name="activity"
                id="activityOptionPrint"
                value="1"
                label="Print"
                [disabled]="showRemovedCopies"
                formControlName="activity"
              >
              </p-radioButton>
              <p-radioButton
                name="activity"
                id="activityOptionRemove"
                value="2"
                label="Remove"
                [disabled]="showRemovedCopies"
                formControlName="activity"
              >
              </p-radioButton>
            </div>
          </div>
        </div>
        <div class="fields-row">
          <div class="field">
            <bpt-dropdown
              label="eQMS Scope(s)*"
              placeholder="Select eQMS Scopes"
              [options]="labsites ?? []"
              [disabled]="showRemovedCopies"
              [editable]="false"
              formControlName="eQMSScope"
              id="hardCopyActivityeQMSScope"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              (ngModelChange)="validateeQMSScope()"
              [ngClass]="{ 'error-highlight': mandatoryFields.eQMSScope }"
            >
            </bpt-dropdown>
          </div>
          <div class="field">
            <bpt-dropdown
              label="Hardcopy Storage Location*"
              [options]="storageLocations ?? []"
              [editable]="false"
              [disabled]="showRemovedCopies"
              formControlName="storageLocation"
              id="hardCopyActivityStorageLocation"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.storageLocation }"
            >
            </bpt-dropdown>
          </div>
        </div>
        <div class="fields-row">
          <div class="field">
            <bpt-numeric-input
              label="Copies*"
              formControlName="copies"
              [showButtons]="true"
              [disabled]="showRemovedCopies"
              (numericInputKeyUp)="onCopiesChanges($event)"
              id="hardCopyActivityCopies"
              [allowKeyboardIncrement]="true"
              placeholder="Copies"
              [ngClass]="{ 'error-highlight': mandatoryFields.copies }"
            >
            </bpt-numeric-input>
          </div>
          <div class="field">
            <bpt-dropdown
              label="Assigned User*"
              [options]="usersAndAssignmentGroupListOptions ?? []"
              [editable]="false"
              formControlName="assignedUser"
              id="hardCopyActivityAssignedUser"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.assignedUser }"
            >
            </bpt-dropdown>
          </div>
          <div *ngIf="showRemovedCopies">
            <div class="field">
              <bpt-numeric-input
                label="RemovedCopies"
                [showButtons]="true"
                formControlName="removedCopies"
                id="removedCopies"
                (numericInputKeyUp)="onCopiesChanges($event)"
                [minValue]="1"
                [maxValue]="maxValueLimit"
                [allowKeyboardIncrement]="true"
                placeholder="RemovedCopies"
              >
              </bpt-numeric-input>
            </div>
          </div>
        </div>
        <div class="fields-row">
          <div class="field">
            <bpt-text-input
              formControlName="notes"
              [highlightAllOnFocus]="true"
              placeholder="EnterNotes"
              [disabled]="showRemovedCopies"
              [multiLine]="true"
              id="hardCopyActivityNotes"
              label="Notes"
            ></bpt-text-input>
          </div>
        </div>
        <p-button
        appPreventDoubleClick
          label="Submit"
          type="submit"
          id="createHardCopyActivitySaveBtn"
          class="align-right"
          (debounceClick)="createHardCopyActivity()"
        >
        </p-button>
      </form>
    </p-panel>
  </div>
</section>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField"
    (confirmed)="saveSessionWithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>